// extracted by mini-css-extract-plugin
export default {"MenuToggle":"MenuToggle_MenuToggle__GEdgd"};